import { Block } from 'factories/block';
import { findBlocksIn } from 'selectors/block';
import { Action, initialState, State, TrackerState } from 'store/store';

export const removeBlock = (
  state: State = initialState,
  { data }: Action
): State => {
  const nextState = {
    ...state,
    blocks: { ...state.blocks },
    tracker: { ...state.tracker },
  };

  nextState.tracker[data.id] = TrackerState.DELETED;

  const all = findBlocksIn(nextState.blocks, data as Block, () => true);

  all.forEach(b => {
    nextState.tracker[b.id] = TrackerState.DELETED;
  });

  return nextState;
};
